'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $tenant = process.env.ELECTRODE_TENANT;
var tenantMessages = void 0;

try {
	tenantMessages = require('./tenants/' + $tenant + '/default-messages'); //eslint-disable-line
} catch (err) {
	tenantMessages = {};
}

var messages = (0, _reactIntl.defineMessages)({
	SEARCH_PLACEHOLDER: {
		'id': 'SEARCH_BAR.SEARCH_PLACEHOLDER',
		'defaultMessage': 'Type in a speciality, condition, procedure, name...'
	},
	LOCATION_PLACEHOLDER: {
		'id': 'SEARCH_BAR.LOCATION_PLACEHOLDER',
		'defaultMessage': 'Location'
	},
	INSURER_PLACEHOLDER: {
		'id': 'SEARCH_BAR.INSURER_PLACEHOLDER',
		'defaultMessage': 'Insurer'
	},
	HOSPITAL_LIST_PLACEHOLDER: {
		'id': 'SEARCH_BAR.HOSPITAL_LIST_PLACEHOLDER',
		'defaultMessage': 'Hospital List'
	},
	SEARCH: {
		'id': 'SEARCH_BAR.SEARCH',
		'defaultMessage': 'Search'
	},
	UPDATE: {
		'id': 'SEARCH_BAR.UPDATE',
		'defaultMessage': 'Update'
	}
});

module.exports = (0, _assign2.default)({}, messages, tenantMessages);


// WEBPACK FOOTER //
// ./components/search-bar/lib/lang/default-messages.js